module.exports = __webpack_public_path__ + "img/arrow-left.3055364d.svg";